"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectDescription = void 0;
const InvalidResult_1 = __importDefault(require("./InvalidResult"));
exports.objectDescription = {
    userFacingTitle: 'object',
    userFacingValue: JSON.stringify,
    validate(value) {
        if (typeof value !== 'object' || value === null) {
            return new InvalidResult_1.default(`Not an object: ${value}`);
        }
        return value;
    },
};
